export default __webpack_public_path__ + "static/media/funnel.9822efe7.svg";